import { render } from "./TheJ05NotificationPanelThanks.vue?vue&type=template&id=0a883f8a&scoped=true&ts=true"
import script from "./TheJ05NotificationPanelThanks.vue?vue&type=script&lang=ts"
export * from "./TheJ05NotificationPanelThanks.vue?vue&type=script&lang=ts"

import "./TheJ05NotificationPanelThanks.vue?vue&type=style&index=0&id=0a883f8a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a883f8a"]])

export default __exports__